<template>
  <div class="product" :class="customClass">
    <template v-if="isProductType(3)">
      <theme-content :product="product"></theme-content>
    </template>

    <template v-else-if="isProductType(4)">
      <template-content :product="product"></template-content>
    </template>

    <template v-else-if="isProductType(5)">
      <paper-content :product="product"></paper-content>
    </template>

    <template v-else-if="isProductType(6)">
      <support-content :product="product"></support-content>
    </template>

    <template v-else-if="isOffer()">
      <offer-content :product="product"></offer-content>
    </template>
  </div>
</template>

<script>
  import Theme from './ThemeContent.vue';
  import Offer from './OfferContent.vue';
  import Paper from './PaperContent.vue';
  import Support from './SupportContent.vue';
  import Template from './TemplateContent.vue';

  export default {
    name: 'product-content',

    components: {
      'theme-content': Theme,
      'offer-content': Offer,
      'paper-content': Paper,
      'support-content': Support,
      'template-content': Template,
    },

    props: {
      product: {
        default: null,
      },

      customClass: {
        required: false,
      }
    },

    methods: {
      isProductType(type) {
        return this.product.product_type_id == type;
      },

      isOffer() {
        return this.product.product_type_id == null;
      },
    },
  };
</script>

<style scoped>
  .product {
    height: 100%;
  }
</style>


// WEBPACK FOOTER //
// resources/assets/js/store/components/ProductContent.vue